query getNewsletterDeliveryDetails($input: GetNewsletterDeliveryDetailsInput!) {
  getNewsletterDeliveryDetails(input: $input) {
    total
    sent
    failed
    pending
    recipients {
      invitationId
      leadId
      leadName
      leadEmail
      companyId
      companyName
      deliveryStatus
      deliveryError
      invitedAt
    }
  }
}
